import { config } from '@utils/config.ts';
import { Cp } from '@services/swagger-client/Cp.ts';
import { Auth } from '@services/swagger-client/Auth.ts';

export const apiCpService = new Cp({
  baseURL: config.apiUrl.origin,
});

export const apiAuthService = new Auth({
  baseURL: config.apiUrl.origin,
});
